import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {RouterModule} from '@angular/router';
import {DataTableModule, EditorModule, SharedModule, FileUploadModule} from 'primeng/primeng';
import {CadensSharedModule} from '../../shared';
import {FilesComponent} from './files/files.component';
import {ParametrageService, ParametrageComponent, parametrageRoute, ParametrageResolvePagingParams} from './';
import {CadensBlocksModule} from '../blocks/blocks.module';

let ENTITY_STATES = [
    ...parametrageRoute,
];

@NgModule({
    imports: [
        CadensSharedModule,
        DataTableModule,
        SharedModule,
        EditorModule,
        SharedModule,
        CadensBlocksModule,
        FileUploadModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ParametrageComponent,
        FilesComponent
    ],
    entryComponents: [
        ParametrageComponent
    ],
    providers: [
        ParametrageService,
        ParametrageResolvePagingParams
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensParametrageModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/parametrage.module.ts